import { get } from './_core.js';

export type ModuleSlug = 'languages' | 'coach' | 'fonix' | 'tools' | 'memory';

export interface ModulePanel {
  slug: ModuleSlug;
  since: string;
  [k: string]: unknown;
}

export async function fetchModulePanel(slug: ModuleSlug): Promise<ModulePanel> {
  const res = await get<ModulePanel>(`/admin/modules/${slug}`);
  return res.data;
}
